module.exports = __webpack_public_path__ + "img/icon-plus.392e1a7b.svg";